import { css } from "@emotion/react";
import { colors, VStack } from "goi_common";

function FacilityFeeSection({ care }: { care: any }) {
  return (
    <>
      <FacilityTable title="직원 현황" th="직원 수" items={care} />
    </>
  );
}

export default FacilityFeeSection;

function FacilityTable({
  title,
  th,
  items,
}: {
  items: any;
  th: string;
  title: string;
}) {
  return (
    <VStack margin="32px 20px 0px" gap="20px">
      <div className="subtitle_14_b">{title}</div>
      <table
        css={css`
          width: 100%;
        `}
      >
        <thead
          css={css`
            background: ${colors.warmGray150};
          `}
          className="caption_12_b gray900"
        >
          <tr>
            <th
              css={css`
                padding: 6px;
                width: 30%;
              `}
            >
              분류
            </th>
            <th
              css={css`
                padding: 6px;
                width: 30%;
              `}
            >
              {th}
            </th>
          </tr>
        </thead>
        <tbody className="caption1 gray900">
          <tr
            css={css`
              text-align: center;
              border-bottom: 1px solid ${colors.gray100};
            `}
          >
            <td
              css={css`
                padding: 10px;
              `}
            >
              의사(전임)
            </td>
            <td
              css={css`
                padding: 10px;
              `}
            >
              {items.doc_fulltime}
            </td>
          </tr>
          <tr
            css={css`
              text-align: center;
              border-bottom: 1px solid ${colors.gray100};
            `}
          >
            <td
              css={css`
                padding: 10px;
              `}
            >
              의사(촉탁)
            </td>
            <td
              css={css`
                padding: 10px;
              `}
            >
              {items.doc_pre}
            </td>
          </tr>
          <tr
            css={css`
              text-align: center;
              border-bottom: 1px solid ${colors.gray100};
            `}
          >
            <td
              css={css`
                padding: 10px;
              `}
            >
              간호사
            </td>
            <td
              css={css`
                padding: 10px;
              `}
            >
              {items.nurse}
            </td>
          </tr>
          <tr
            css={css`
              text-align: center;
              border-bottom: 1px solid ${colors.gray100};
            `}
          >
            <td
              css={css`
                padding: 10px;
              `}
            >
              간호조무사
            </td>
            <td
              css={css`
                padding: 10px;
              `}
            >
              {items.nurse_assistant}
            </td>
          </tr>
          <tr
            css={css`
              text-align: center;
              border-bottom: 1px solid ${colors.gray100};
            `}
          >
            <td
              css={css`
                padding: 10px;
              `}
            >
              요양보호사
            </td>
            <td
              css={css`
                padding: 10px;
              `}
            >
              {items.caregiver}
            </td>
          </tr>
        </tbody>
      </table>
    </VStack>
  );
}
